import React, { useState } from "react";
import { KeyRound, Save } from "lucide-react";
import { practiceApi } from "../lib/practiceApi";
import { SignatureUpload } from "./SignatureUpload";

const EMPTY = { current_password: "", new_password: "", repeat: "" };

export const AccountSecurity = ({ user, onUser }) => {
  const [form, setForm] = useState(EMPTY);
  const [profile, setProfile] = useState({ name: user.name || "", first_name: user.first_name || "" });
  const [profileState, setProfileState] = useState({ busy: false, error: "", done: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState("");

  async function saveProfile(event) {
    event.preventDefault();
    setProfileState({ busy: true, error: "", done: "" });
    try {
      const updated = await practiceApi("/auth/profile", { method: "PUT", body: JSON.stringify(profile) });
      onUser?.(updated);
      setProfileState({ busy: false, error: "", done: "Nome aggiornato: comparirà subito nel saluto della dashboard." });
    } catch (err) { setProfileState({ busy: false, error: err.message, done: "" }); }
  }

  async function submit(event) {
    event.preventDefault();
    setError(""); setDone("");
    if (form.new_password.length < 8) { setError("La nuova password deve contenere almeno 8 caratteri"); return; }
    if (form.new_password !== form.repeat) { setError("Le due password non coincidono"); return; }
    setBusy(true);
    try {
      await practiceApi("/auth/change-password", { method: "POST", body: JSON.stringify({ current_password: form.current_password, new_password: form.new_password }) });
      setForm(EMPTY);
      setDone("Password aggiornata. Usa la nuova password al prossimo accesso.");
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  return <>
    <form className="settings-account" data-testid="account-profile" onSubmit={saveProfile}>
      <div className="practice-notice" data-testid="account-identity">
        <strong>{user.name}</strong> · {user.email} · {user.role === "admin" ? "Amministratore" : "Consulente"}
      </div>
      <p className="muted">Come ti chiami. Il "nome" è quello usato nel saluto della dashboard: compilalo se la tua anagrafica è scritta come "Cognome Nome".</p>
      <div className="practice-form-grid">
        <label>Nome (per il saluto)<input data-testid="account-first-name" placeholder="Gianluca" value={profile.first_name} onChange={e => setProfile({ ...profile, first_name: e.target.value })} /></label>
        <label>Nome completo<input required data-testid="account-full-name" placeholder="Di Gesù Gianluca" value={profile.name} onChange={e => setProfile({ ...profile, name: e.target.value })} /></label>
      </div>
      {profileState.error && <div className="error" role="alert" data-testid="account-profile-error">{profileState.error}</div>}
      {profileState.done && <div className="flash" data-testid="account-profile-saved">{profileState.done}</div>}
      <div className="settings-actions">
        <button className="primary" type="submit" disabled={profileState.busy} data-testid="account-profile-submit"><Save size={15} />{profileState.busy ? "Salvataggio…" : "Salva nome"}</button>
      </div>
    </form>
    <form className="settings-account" data-testid="account-security" onSubmit={submit}>
    <p className="muted">Cambia la password del tuo accesso. Le altre sessioni aperte verranno disconnesse.</p>
    <div className="practice-form-grid">
      <label>Password attuale<input type="password" required autoComplete="current-password" data-testid="account-current-password" value={form.current_password} onChange={e => setForm({ ...form, current_password: e.target.value })} /></label>
      <label>Nuova password<input type="password" required autoComplete="new-password" data-testid="account-new-password" value={form.new_password} onChange={e => setForm({ ...form, new_password: e.target.value })} /></label>
      <label>Ripeti nuova password<input type="password" required autoComplete="new-password" data-testid="account-repeat-password" value={form.repeat} onChange={e => setForm({ ...form, repeat: e.target.value })} /></label>
    </div>
    {error && <div className="error" role="alert" data-testid="account-error">{error}</div>}
    {done && <div className="flash" data-testid="account-saved">{done}</div>}
    <div className="settings-actions">
      <button className="primary" type="submit" disabled={busy} data-testid="account-submit"><Save size={15} />{busy ? "Aggiornamento…" : "Aggiorna password"}</button>
      <span className="muted" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12 }}><KeyRound size={13} />Minimo 8 caratteri</span>
    </div>
    </form>
    <div className="settings-assets" data-testid="account-signature">
      <SignatureUpload userId="me" name={user.name} testid="account-stamp" />
    </div>
  </>;
};
